import type { RawAxiosRequestHeaders } from 'axios';

const ORGANIZATION_HEADER = 'x-organization-id';

// axios はヘッダ名を trim + 小文字化して扱い、表記違いの同名キーは後ろが勝つ (undefined なら削除)。
// 同名のキーを表記を問わず全て除いてから確定値を置き、呼び出し側が確定値を潰せないようにする。
export const withOrganizationHeader = (
  headers: RawAxiosRequestHeaders | undefined,
  organizationId: string,
): RawAxiosRequestHeaders => ({
  ...Object.fromEntries(
    Object.entries(headers ?? {}).filter(([name]) => name.trim().toLowerCase() !== ORGANIZATION_HEADER),
  ),
  [ORGANIZATION_HEADER]: organizationId,
});
